import { ActionType } from "./types"

const setFiles = (data: Array<Object>) => {
  return {
    type: ActionType.SET_FILES,
    payload: data
  }
}

export default setFiles
